export default __webpack_public_path__ + "static/media/sketch.f6d92338.svg";